import { Street, StreetList } from '@/types/address/addressType'
import { Translator } from '../../types/ApiResponseTypes'
import { isStreetListResponse, StreetResponse } from '@/types/address/addressReponse'

class StreetResponseTranslator implements Translator<StreetList> {
  convert(response: any): StreetList {
    if (isStreetListResponse(response)) {
      const streetObject: Array<Street> = []
      if (Array.isArray(response)) {
        response.forEach((street: StreetResponse) => {
          streetObject.push(this.convertTostreetModel(street))
        })
        return { streets: streetObject }
      }
    }
    return { streets: [] }
  }

  convertTostreetModel(response: StreetResponse): Street {
    return {
      id: response.streetId,
      name: response.streetName,
    }
  }
}
export default new StreetResponseTranslator()
